import { ref, computed } from 'vue';

/**
 * 概览视图 Swiper 逻辑 Hook
 * 提供垂直滚动的 Swiper 配置、状态管理和控制方法
 *
 * @returns {Object} Swiper 相关的配置、状态和方法
 */
export function useOverviewSwiper(options = {}) {
	const { slideModuleIdAttribute = null } = options;

	const swiperRef = ref();
	const activeSwiperIndex = ref(0);
	const getSwiper = computed(() => swiperRef.value?.$swiper);

	const speed = 600;
	const swiperOption = {
		slidesPerView: 'auto',
		direction: 'vertical',
		resistanceRatio: 0,
		autoHeight: true,
		speed,
		mousewheel: true,
		lazy: {
			loadPrevNext: true,
			loadOnTransitionStart: true
		},
		simulateTouch: false,
		on: {
			slideChange: () => {
				changeSwiper();
			},
			transitionStart: () => {
				console.log('------ start.');
				lockSwiper();
			},
			transitionEnd: () => {
				console.log('------ end.');
				unlockSwiper();
			}
		}
	};

	const changeSwiper = () => {
		const actIdx = getSwiper.value?.activeIndex;
		activeSwiperIndex.value = actIdx;
	};

	const lockSwiper = () => {
		getSwiper.value?.mousewheel.disable();
	};

	const unlockSwiper = () => {
		console.log('unlock');
		setTimeout(() => {
			getSwiper.value?.mousewheel.enable();
		}, speed + 300); // TODO timeout
	};

	const updateSwiper = () => {
		getSwiper.value?.update(true);
	};

	const slideToTarget = target => {
		if (!target) return;
		if (!slideModuleIdAttribute) return;

		const swiper = getSwiper.value;
		const slides = swiper?.slides || [];
		for (let i = 0; i < slides.length; i++) {
			const slide = slides[i];
			const moduleId = slide.getAttribute(slideModuleIdAttribute);
			if (moduleId === target) {
				swiper?.slideTo(i, 0, false);
				break;
			}
		}
	};

	/**
	 * 设置 ResizeObserver 监听容器变化并更新 Swiper
	 * @param {string} selector - 容器选择器
	 */
	const setupResizeObserver = selector => {
		const wrapper = document.querySelector(selector);
		if (!wrapper) return;

		const ro = new ResizeObserver(() => {
			const swiper = getSwiper.value;
			if (swiper) {
				swiper.update(true);
			}
		});

		ro.observe(wrapper);
	};

	return {
		swiperRef,
		swiperOption,
		activeSwiperIndex,
		getSwiper,
		changeSwiper,
		lockSwiper,
		unlockSwiper,
		updateSwiper,
		slideToTarget,
		setupResizeObserver
	};
}
